import { Car } from './car';
import { Document } from './document';
import { SinisterGlass } from './sinister-glass';

import { LocationDataGeocoded } from '../location';

export interface Claim {
  sinisterDate?: Date;
  sinisterPlace?: LocationDataGeocoded;
  car?: Car;
  glass?: SinisterGlass;
  documents?: Document[];
  eurocode?: string;
  constructorRef?: string;
  operationType?: OperationType;
  /** @deprecated Read only for migration. Add comments to Dossier.dossierComments. */
  sinisterComment?: string;
  sinisterLocation?: string;
  sinisterContext?: SinisterContext;
  calibration?: CalibrationType;
}

export interface SinisterContext {
  key: XCircumstance;
  value?: string;
}

/**
 * 'G' : Projection de caillou
 * | 'T' : Tiers identifié
 * | 'O' : Autre
 * | 'V' : Vandalisme
 * | 'NE' : Evenement naturel
 * | 'P' : En stationnement
 * | 'A' : Bris par acciden
 * | 'U' : Ne sais pas
 */
export enum XCircumstanceEnum {
  G = 'G',
  T = 'T',
  V = 'V',
  U = 'U',
  NE = 'NE',
  O = 'O',
  A = 'A',
  P = 'P',
}

export type XCircumstance = `${XCircumstanceEnum}`;

export enum OperationTypeEnum {
  Repair = 'Repair',
  Replace = 'Replace',
}
export type OperationType = `${OperationTypeEnum}`;

export enum CalibrationEnum {
  True = 'true',
  False = 'false',
  Unknown = 'unknown',
}
export type CalibrationType = `${CalibrationEnum}`;
